import {useTranslations} from '@/i18n/hooks/useTranslations'
import {type Navigation} from '@/types/navigation'

export const createNavigation = (t: ReturnType<typeof useTranslations>): Navigation => ({
  users: {
    title: t('navigation.links.users.title'),
    links: [
      {name: t('navigation.links.users.howItWorks'), href: '/use-piffl'},
      {name: t('navigation.links.users.activities'), href: '/activities'},
      {name: t('navigation.links.users.findBox'), href: '/boxes'},
    ],
  },
  citiesAndPartners: {
    title: t('navigation.links.citiesAndPartners.title'),
    links: [
      {
        name: t('navigation.links.citiesAndPartners.getPiffl'),
        href: '/get-piffl',
      },
      {
        name: t('navigation.links.citiesAndPartners.portal'),
        href: 'https://portal.piffl.se/',
        external: true,
      },
      // {
      //   name: t('navigation.links.citiesAndPartners.referenceProjects'),
      //   href: '/reference-projects',
      // },
      {
        name: t('navigation.links.citiesAndPartners.activities'),
        href: '/activities',
      },
      {
        name: t('navigation.links.citiesAndPartners.news'),
        href: 'https://www.mynewsdesk.com/se/piffl',
        external: true,
      },
      {name: t('navigation.links.citiesAndPartners.aboutUs'), href: '/about'},
      {name: t('navigation.links.citiesAndPartners.contact'), href: '/contact'},
    ],
  },
  help: {
    title: t('navigation.links.help.title'),
    links: [
      {name: t('navigation.links.help.contact'), href: '/contact'},
      {name: t('navigation.links.help.faq'), href: '/faq'},
    ],
  },
})
